import { render, staticRenderFns } from "./CloseBuy.vue?vue&type=template&id=1ec2e534&scoped=true&"
import script from "./CloseBuy.vue?vue&type=script&lang=js&"
export * from "./CloseBuy.vue?vue&type=script&lang=js&"
import style0 from "./CloseBuy.vue?vue&type=style&index=0&id=1ec2e534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2e534",
  null
  
)

export default component.exports